module.exports = {
  server: 'https://api.ecobox.guoqi999.com'
}
